var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOauthGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 0C72.182 0 93 21.3432 93 47.6761C93 68.736 79.6917 86.6014 61.2266 92.9115C58.869 93.3811 58.032 91.8922 58.032 90.6228C58.032 89.0511 58.0878 83.9176 58.0878 77.5378C58.0878 73.0925 56.5998 70.1911 54.9305 68.7124C65.286 67.5313 76.167 63.4994 76.167 45.1877C76.167 39.9797 74.3628 35.7298 71.3775 32.3911C71.8611 31.1867 73.456 26.3374 70.9218 19.7716C70.9218 19.7716 67.0251 18.4941 58.1482 24.66C54.4329 23.6044 50.4525 23.0733 46.5 23.0547C42.5475 23.0733 38.5718 23.6044 34.8611 24.66C25.9749 18.4941 22.0689 19.7716 22.0689 19.7716C19.544 26.3374 21.1389 31.1867 21.6179 32.3911C18.6465 35.7298 16.8284 39.9797 16.8284 45.1877C16.8284 63.4529 27.6861 67.5466 38.0138 68.751C36.6839 69.9414 35.4795 72.0414 35.061 75.1243C32.4105 76.3426 25.6773 78.4511 21.5295 71.1645C21.5295 71.1645 19.0697 66.5837 14.4011 66.2489C14.4011 66.2489 9.8673 66.1887 14.0848 69.1461C14.0848 69.1461 17.1306 70.6108 19.2463 76.1211C19.2463 76.1211 21.9759 84.6304 34.9122 81.7474C34.9355 85.7324 34.9773 89.4882 34.9773 90.6228C34.9773 91.8829 34.1217 93.3577 31.8013 92.916C13.3222 86.6152 0 68.7406 0 47.6761C0 21.3432 20.8227 0 46.5 0Z",
    fill: "#B5D7C9",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOauthGithub);
export default __webpack_public_path__ + "static/media/oauth-github.148619f5f1f63a5a1b6b73b9e9319977.svg";
export { ForwardRef as ReactComponent };